<template>
  <header>
    <div class="container">
      <div class="header-content">
        <div class="header-logo">
          <img
            src="@/assets/images/unipol/logo/ssc.png"
            alt="Ascensos"
          >
        </div>
        <div class="header-menu">
          <scrollactive
            active-class="active"
            :offset="80"
          >
            <ul>
              <li>
                <a
                  href="#inicio"
                  class="link scrollactive-item"
                >Inicio</a>
              </li>
              <li>
                <a
                  href="#convocatorias"
                  class="link scrollactive-item"
                >Convocatorias</a>
              </li>
            </ul>
          </scrollactive>
        </div>
      </div>
      <div class="responsive-header-menu">
        <scrollactive
          active-class="active"
          :offset="80"
          tag="div"
        >
          <ul>
            <li>
              <a
                href="#inicio"
                class="link scrollactive-item"
              >Inicio</a>
            </li>
            <li>
              <a
                href="#convocatorias"
                class="link scrollactive-item"
              >Convocatorias</a>
            </li>
          </ul>
        </scrollactive>
      </div>
    </div>
  </header>
</template>

<script>

export default {
  components: {
  },
  methods: {
    goRegistro() {
      const vm = this
      vm.$router.push({ name: 'registro' })
    },
  },
}
</script>

<style>
.btn-header {
  font-size: 12px;
}
</style>
